import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Grid } from '@mui/material';

import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import NotificationsBlock from './NotificationsBlock';
import TeamBlock from './TeamBlock';
import RAFBlock from "@common/components/DashboardLayout/RAFBlock";

const DashboardLayout = ({
                           children,
                           team,
                           hideNotifications = false,
                           hideExtraWidgets = false,
                           noXSPaddings = false,
                           flexCenterContent = false,
                           showReferAFriend = false,
                           extraBottomPadding = false,
                           hideTeam = false,
                           inProgress
}) => {
  const { notifications } = useSelector(state => state.notifications);
  const dimensions = useSelector(state => state.dimensions);

  return (
    <Box className={`${styles.pageWrapper} ${noXSPaddings ? styles.noXSPaddings : ''}`}>
      <Box sx={{ mb: 1, mt: 0 }} className={`${styles.dashboardContainer} ${extraBottomPadding ? styles.extraBottomPadding : ''}`}>
        <Grid container justifyContent="space-between" alignItems="flex-start" alignContent="flex-start">
          <Grid
            item
            container={!!flexCenterContent}
            className={`${styles.dashboardContent} ${hideExtraWidgets ? styles.fullWidth : ''}`}
            justifyContent={flexCenterContent ? 'center' : undefined}
          >
            {(!dimensions?.isScreenBiggerSM) && (<>
              {(!!notifications?.elements?.length && !hideNotifications && !hideExtraWidgets) && (
                <NotificationsBlock />
              )}
              <TeamBlock isHidden />
            </>)}
            {children}
            {inProgress && (<CircularProgress size={80} className={styles.cardProgress} />)}
          </Grid>
          {(dimensions?.isScreenBiggerSM && !hideExtraWidgets) && (
            <Grid item className={styles.rightBlock}>
              <TeamBlock isHidden={!!hideTeam} />
              {showReferAFriend && <RAFBlock />}
              {!hideNotifications && <NotificationsBlock />}
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  )
};

DashboardLayout.propTypes = {
  team: PropTypes.arrayOf(PropTypes.object),
  hideNotifications: PropTypes.bool,
  hideExtraWidgets: PropTypes.bool
};

export default DashboardLayout;